import { injectable } from 'inversify';
import { AuthPort } from '../../../core/port/auth.port';

@injectable()
export class InMemoryAuthRepository implements AuthPort {
  async canAccess(): Promise<boolean> {
    return true;
  }
}
